import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-sb-belasting',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-belasting.component.html',
  styleUrl: './tekst-belasting.component.scss',
})
export class TekstBelastingComponent {}
